import { combineSlices } from '@reduxjs/toolkit'
import spinnerSlice from './spinner.slice'

export type RootState = {
    spinner: ReturnType<typeof spinnerSlice.reducer>
}

export const rootReducer = combineSlices(spinnerSlice)
